<div *ngIf="!isLoading">
  <p-chart #retentionDonut type="doughnut" [data]="chartData" [options]="chartOptions" [height]="157"></p-chart>
  <div   class="w-55 mct-flex mct-col mct-gap-6" style="margin: 0 auto;">
    <div class="retention-total mt-30 mct-flex mct-row mct-justify-start mct-items-center mct-gap-8"   >
      <div class="chart-legend-colorbox" [ngStyle]="{ 'background-color': colors[0] }"></div>
      <div class="card-field-label f-wb">{{ 'dashboard.retention.investment-retention' | translate | titlecase }}</div>
    </div>
    <div class="mct-flex mct-row mct-justify-start mct-items-center mct-gap-3"   >
      <div class="card-field-label">{{ 'dashboard.retention.overall' | translate | titlecase }}</div>
      <div class="chart-legend-value">{{ chartData?.datasets[0]?.data[0] | percent }}</div>
    </div>
  </div>
</div>
